<template>
  <div>
    <router-view @page-change="onPageChange" />
  </div>
</template>

<script>
export default {
  name: 'BookView',
  components: {},
  data() {
    return {
      page: {
        type: Object,
        default: () => {},
      },
    };
  },
  methods: {
    onPageChange(page) {
      this.page = page;
    },
  },
};
</script>
